import { Typography } from "@mui/material";

interface InfoRowProps {
  label: string;
  value?: string | null;
}

export const InfoRow = ({ label, value }: InfoRowProps) => {
  if (!value) return null;
  
  return (
    <Typography variant="body1" sx={{ mb: 1 }}>
      <strong>{label} :</strong> {value}
    </Typography>
  );
};
